import { Container } from "react-bootstrap";
import Navigation from "../../../Components/Navbar";
import Servicos from './servicos';
const Oficina = () => {

    return (
        <div>
            <Navigation />
            <div className="container-lg">
                <Servicos />
            </div>
        </div>
    )
}

export default Oficina;